/**
 * Shared rendering of the measured-depth advice (SPEC v0.9.3 D8) so the result card,
 * gauge popups and the "จุดท่วมสูงสุด" tab all show the SAME owner-approved text, with
 * "1784" as a tappable tel: link. Advice text itself comes from @flowsight/sim.
 */
import { depthAdviceCm } from "@flowsight/sim";

const esc = (s: string): string => s.replace(/[<>&"]/g, (c) => ({ "<": "&lt;", ">": "&gt;", "&": "&amp;", '"': "&quot;" }[c] ?? c));

/** Escape text and turn any "1784" into a tel: link. */
export function telize(text: string): string {
  return esc(text).replace(/1784/g, '<a href="tel:1784">1784</a>');
}

/** "<icon> <advice with tel:1784>" for a given depth in cm. */
export function depthAdviceHtml(cm: number): string {
  const a = depthAdviceCm(cm);
  return `${a.icon} ${telize(a.advice)}`;
}
